import { EcmrAccessInfo } from './EcmrAccessInfo';

export interface DriverAssignLinkParams {
  transportId: string;
  accessCode?: string;
  companyId?: string;
  /** The tenant inside ecmrAccessInfo; read only when that is asked for. */
  submitter?: string;
  /** TF-20753. Only the planning tool sends it for now. */
  ecmrAccessInfo?: boolean;
}

export class DriverAssignLink {
  /** The transport access URL, which every producer of a transport QR builds. */
  static readonly PATH = 'universal/driver-assign';

  /** Pre-TF-20797; codes already printed carry it, so it redirects rather than retires. */
  static readonly LEGACY_PATH = 'messenger/driver-assign';

  /**
   * Undefined rather than a throw when the origin or transport is unusable, as DriveWebAppLink:
   * these are built in ngOnInit. Only truthy parameters are written, so a missing access code is
   * left out rather than sent as the string "undefined".
   */
  static transportUrl(origin: string, params: DriverAssignLinkParams): string {
    if (!origin || !params.transportId) {
      return undefined;
    }

    let url: URL;
    try {
      url = new URL(DriverAssignLink.PATH, origin.endsWith('/') ? origin : `${origin}/`);
    } catch {
      return undefined;
    }

    // Not URLSearchParams: it writes a space as '+', which the router reads back as a literal '+'.
    url.search = Object.entries({
      companyId: params.companyId,
      transportId: params.transportId,
      accessCode: params.accessCode,
      ecmrAccessInfo: params.ecmrAccessInfo
        ? EcmrAccessInfo.encode(params.accessCode, params.submitter)
        : undefined,
    })
      .filter(([, value]) => value)
      .map(([name, value]) => `${name}=${encodeURIComponent(value)}`)
      .join('&');

    return url.toString();
  }
}
